import {
    EULAPage,
    Messenger,
    VehicleList,
    MultiDBViewer,
    Help,
    QRList,
    CompanyPolicy,
    SeatedUsers,
    MasterSSWPFormCreator,
    DashboardV2,
    SubmittedReportsV2,
    RequestedTMPlans,
    // DailyWorkSheetList,
    UserManagerV4 as UM,
    UserPerformance,
    JobPackManager as JPM,
    FileManager,
    Alerts,
    HolidayRequestManager,
    QualificationsManagerV2,
    ResourcePlanner as RP,
    TimesheetManager,
    SecurityConfig,
    ToolBoxManager,
    Tutorials,
    EWCCodes,
    WasteDisposalList,
    WeekPlannerV2,
    Hsqe,
    HsqeReport,
    ExcelDownloader,
    CompanyAnalytics,
    VehicleChecklistTemplate
} from "../lib";
//import { Note, Security } from "@material-ui/icons";
import React from "react";

import {
    tableConfig,
    userManagerTableConfig,
    userProfile,
} from "./dataConfigs";

const ResourcePlanner = {
    ...RP,
    view: (props) => {
        return (
            <RP.view
                {...props}
                resourceSubjectFirebasePath={"/users"}
                resourceNameLodashPath={[
                    "profile.first_name",
                    "profile.last_name",
                ]}
                trackSubjectFirebasePath={"/subjects/machines"}
                trackNameLodashPath={[
                    // "profile.machine_reg",
                    "profile.machine_desc",
                ]}
                name="Vehicle Planner"
            />
        );
    },
};

const JobPackManager = {
    ...JPM,
    view: (props) => {
        return <JPM.view {...props} tableConfig={tableConfig} />;
    },
};
const UserManager = {
    ...UM,
    view: (props) => {
        return (
            <UM.view
                {...props}
                tableConfig={userManagerTableConfig}
                userProfile={userProfile}
            />
        );
    },
};

const pages = [
    {
        type: "page",
        label: "Home",
        link: "/dashboard",
        component: DashboardV2,
        icon: "Computer",
        access_level: "dashboard_page",
        security_level: ["Admin"],
    },
    {
        type: "page",
        label: "Alerts",
        link: "/alerts",
        component: Alerts,
        icon: "Warning",
        access_level: "alerts",
        security_level: ["Admin"],
    },
    {
        type: "page",
        label: "Data Analysis Overview",
        link: "/companyanalytics",
        component: CompanyAnalytics,
        icon: "BarChartOutlinedIcon",
        access_level: "companyanalytics",
        security_level: ["Admin"],
    },
    {
        type: "JM",
        label: "Job Managment",
        icon: "Assignment",
        sub_pages: [
            {
                type: "page",
                label: "Jobpack Manager",
                link: "/job-pack-manager/list",
                component: JobPackManager,
                icon: "BusinessCenter",
                access_level: "jobpack",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Week Planner",
                link: "/week-planner",
                component: WeekPlannerV2,
                icon: "EventNote",
                access_level: "roster",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "EWC Codes",
                link: "/ewc-codes",
                component: EWCCodes,
                icon: "Code",
                access_level: ["ewc_codes"],
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Waste Disposal Sites",
                link: "/waste-disposal-sites",
                component: WasteDisposalList,
                icon: "DeleteSweep",
                access_level: ["waste_disposal_sites"],
                security_level: ["Admin"],
            },
        ],
        access_level: "alerts",
        security_level: ["Admin"],
    },
    {
        type: "RM",
        label: "Report Management",
        icon: "Note",
        sub_pages: [
            {
                type: "page",
                label: "Submitted Reports",
                link: "/submitted-reports",
                component: SubmittedReportsV2,
                icon: "ListAlt",
                access_level: "submitted_reports",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Master SSWP Form",
                link: "/master-sswp",
                component: MasterSSWPFormCreator,
                icon: "Warning",
                access_level: "master_sswp_v2",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Holiday Request",
                link: "/holiday-request",
                component: HolidayRequestManager,
                icon: "AirplanemodeActive",
                access_level: "holiday_request",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Inspection Template Wizard",
                link: "/hsqe",
                component: Hsqe,
                icon: "Flare",
                access_level: "hsqe_template",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "HSQE Report",
                link: "/hsqereport",
                component: HsqeReport,
                icon: "List",
                access_level: "hsqe",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Report Download",
                link: "/exceldownloader",
                component: ExcelDownloader,
                icon: "GetApp",
                access_level: "exceldownloader",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "File Manager",
                link: "/file-manager",
                component: FileManager,
                icon: "Description",
                access_level: "file_manager",
                security_level: ["Admin"],
            },
            // {
            //     type: "page",
            //     label: "Daily Worksheets",
            //     link: "/daily-worksheets",
            //     component: DailyWorkSheetList,
            //     icon: "Note",
            //     access_level: "daily_work_sheet",
            //     security_level: ["Admin"],
            // },
        ],
        access_level: "alerts",
        security_level: ["Admin"],
    },
    {
        type: "UM",
        label: "User Management",
        icon: "SupervisedUserCircle",
        sub_pages: [
            {
                type: "page",
                label: "User Manager",
                link: "/user-manager",
                component: UserManager,
                icon: "People",
                access_level: "user_manager",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Qualifications Manager",
                link: "/qualifications-manager",
                component: QualificationsManagerV2,
                icon: "ContactMail",
                access_level: "qualifications_manager",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Timesheet Manager",
                link: "/timesheet-manager",
                component: TimesheetManager,
                icon: "Schedule",
                access_level: "timesheets",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "User Performance",
                link: "/user-performance",
                component: UserPerformance,
                icon: "TrendingUp",
                access_level: "user_performance",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Messenger",
                link: "/messenger",
                component: Messenger,
                icon: "Chat",
                access_level: "messenger",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Access Levels",
                link: "/security-configurations",
                component: SecurityConfig,
                icon: "Security",
                access_level: "security_config",
                security_level: ["Admin"],
            },
        ],
        access_level: "jobpack",
        security_level: ["Admin"],
    },
    {
        type: "REM",
        label: "Resource Management",
        icon: "EmojiTransportation",
        sub_pages: [
            {
                type: "page",
                label: "Vehicle/Plant Manager",
                link: "/vehicle-list",
                component: VehicleList,
                icon: "DirectionsCar",
                access_level: "machine_manager",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Equipment Manager",
                link: "/equipment-manager",
                component: QRList,
                icon: "Build",
                access_level: "equipment_manager",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Vehicle Planner",
                link: "/vehicle-planner",
                component: ResourcePlanner,
                icon: "CalendarToday",
                access_level: "resource_planner",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Vehicle Inspection Wizard",
                link: "/vehicle-template",
                component: VehicleChecklistTemplate,
                icon: "Flare",
                access_level: "vehiclechecklist_template",
                security_level: ["Admin"],
            },
        ],
        access_level: "jobpack",
        security_level: ["Admin"],
    },
    {
        type: "SU",
        label: "Support",
        icon: "HelpOutline",
        sub_pages: [
            {
                type: "page",
                label: "Tutorials",
                link: "/tutorials",
                component: Tutorials,
                icon: "YouTube",
                access_level: "tutorials",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Toolbox Talks",
                link: "/toolbox-talks",
                component: ToolBoxManager,
                icon: "Assignment",
                access_level: "toolbox_talks",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "User Request",
                link: "/help",
                component: Help,
                icon: "Forum",
                access_level: "help",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "EULA",
                link: "/eula",
                component: EULAPage,
                icon: "PlaylistAddCheck",
                access_level: "eula",
                security_level: ["Admin", "User"],
            },
            {
                type: "page",
                label: "Company Policy",
                link: "/company-policy",
                component: CompanyPolicy,
                icon: "FileCopy",
                access_level: "company_policies",
                security_level: ["Admin"],
            },
        ],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
        security_level: ["Admin"],
    },
    {
        type: "PT",
        label: "Prowork Tools",
        icon: "Business",
        sub_pages: [
            {
                type: "page",
                label: "User Seats",
                link: "/user-seats",
                component: SeatedUsers,
                icon: "People",
                access_level: "seated_users",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Requested TMPlans",
                link: "/requested-tm-plans",
                component: RequestedTMPlans,
                icon: "ChatBubble",
                access_level: "requested_tm_plans",
                security_level: ["Admin"],
            },
            {
                type: "page",
                label: "Multi DB Viewer",
                link: "/multi-db-viewer",
                component: MultiDBViewer,
                icon: "Storage",
                access_level: "multi_db_viewer",
                security_level: ["Admin"],
            },
        ],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
        security_level: ["Admin"],
    },
];

export default pages;
